import { Injectable, OnDestroy, Signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export abstract class InactivityService implements OnDestroy {
  /** True when the session has been terminated due to inactivity. Used by the layout overlay. */
  abstract readonly isDisconnected: Signal<boolean>;
  /** Idle timeout in minutes, for display in the reconnect overlay. */
  abstract readonly inactivityMinutes: number;
  abstract ngOnDestroy(): void;
}
